module.exports = __webpack_public_path__ + "static/cbam-works-1-3cc79ba976443a82fd8d65812df7d265.png";